import { useRoutes } from "react-router-dom";
import { Apptheme } from "./components";
import { AuthProvider } from "./contexts/JWTAuthContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import routes from "./routes";
import "../fake-db";
import { HMSRoomProvider } from '@100mslive/react-sdk';
import { Provider } from "react-redux";


const App = () => {
    const content = useRoutes(routes);
  
    return (
       <SettingsProvider>
          <Apptheme>
            <AuthProvider>{content}</AuthProvider>
          </Apptheme>
        </SettingsProvider>
      
    );
  };
  //  <Provider store={Store}>
      {/* <HMSRoomProvider> */}
    
      // <SettingsProvider>
      //     <Apptheme>
      //       <AuthProvider>{content}</AuthProvider>
      //     </Apptheme>
      //   </SettingsProvider>

  {/* </HMSRoomProvider> */}
      {/* </Provider>  */}
  export default App;


// import { useRoutes } from "react-router-dom";
// import { Apptheme } from "./components";
// import { AuthProvider } from "./contexts/JWTAuthContext";
// import { SettingsProvider } from "./contexts/SettingsContext";
// import routes from "./routes";
// import "../fake-db";
// import { HMSRoomProvider } from '@100mslive/react-sdk';
// import { GoogleOAuthProvider } from "@react-oauth/google";

// const App = () => {
//   const content = useRoutes(routes);

//   return (
//     <GoogleOAuthProvider clientId="825974410817-8enp5duoh2nqgm57b80p550mgbf52aar.apps.googleusercontent.com">
//       <HMSRoomProvider>
//         <SettingsProvider>
//           <Apptheme>
//             <AuthProvider>{content}</AuthProvider>
//           </Apptheme>
//         </SettingsProvider>
//       </HMSRoomProvider>
//     </GoogleOAuthProvider>
//   );
// };

// export default App;
